import {
  standardDetailFilterSchema,
  StandardDetailFilterSchema,
} from '@input-web/modules/standard/models/standard-detail-filter.model';
import standardLayoutRoute from '@input-web/modules/standard/views/layout/standard-layout.route';
import { createRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import StandardDetailLayoutView from './standard-detail-layout.view';

const standardDetailLayoutRoute = createRoute({
  component: StandardDetailLayoutView,
  getParentRoute: () => standardLayoutRoute,
  path: '/standards/$partId',
  validateSearch: {
    ...zodValidator(standardDetailFilterSchema),
    parse: (input: StandardDetailFilterSchema) => standardDetailFilterSchema.safeParse(input).data,
  },
});

export default standardDetailLayoutRoute;
